import type { SVGProps } from "react";
export interface FileAudioIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function FileAudioIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: FileAudioIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M2.875 19V5A4.125 4.125 0 0 1 7 .875h6.586c.293 0 .58.063.844.177l.022.009q.258.115.48.296l.157.14 5.414 5.415c.18.18.322.39.426.618q.012.022.022.047c.113.262.174.547.174.838V19A4.125 4.125 0 0 1 17 23.125H7A4.125 4.125 0 0 1 2.875 19m12.25-13c0 .484.392.875.875.875h1.285l-2.16-2.16zm-10 13c0 1.035.84 1.875 1.875 1.875h10c1.036 0 1.875-.84 1.875-1.875V9.125H16A3.125 3.125 0 0 1 12.876 6V3.125H7c-1.036 0-1.875.84-1.875 1.875z"
      />
      <path
        fill={color}
        d="M14.584 12.597a1.126 1.126 0 0 1 1.472-.325l.097.063.327.257c.72.635 1.145 1.485 1.145 2.409 0 1.055-.557 2.013-1.472 2.665l-.097.062a1.125 1.125 0 0 1-1.208-1.894l.142-.113c.3-.263.385-.529.385-.72 0-.192-.084-.46-.385-.723l-.142-.112-.091-.07a1.126 1.126 0 0 1-.173-1.5Zm-4.049 1.211c-.21.205-.492.32-.785.32H8.625v1.754H9.75l.217.02c.213.043.41.146.568.3l.84.817v-4.031zm3.09 4.695c0 1.436-1.729 2.17-2.76 1.163l-1.572-1.534H8.5a2.127 2.127 0 0 1-2.125-2.127v-2.002c0-1.173.95-2.126 2.125-2.126h.791l1.574-1.535.202-.168c1.04-.743 2.557-.014 2.557 1.331z"
      />
    </svg>
  );
}
